const FilledTick = ({ fill = '#CB1D8D', size = 32 }) => {
  return (
    <svg
      height={size}
      width={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0397 4.45827C14.6445 3.84725 17.3555 3.84724 19.9603 4.45826C23.7221 5.34066 26.6593 8.27789 27.5417 12.0397C28.1528 14.6445 28.1528 17.3555 27.5417 19.9603C26.6593 23.7221 23.7221 26.6593 19.9603 27.5417C17.3555 28.1528 14.6445 28.1528 12.0397 27.5417C8.27789 26.6593 5.34066 23.7221 4.45827 19.9603C3.84724 17.3555 3.84724 14.6445 4.45827 12.0397C5.34066 8.27788 8.27789 5.34066 12.0397 4.45827ZM20.0699 13.9697C20.3585 13.6605 20.3418 13.1759 20.0326 12.8873C19.7234 12.5987 19.2387 12.6155 18.9502 12.9247L15.0237 17.1316L13.0314 15.1393C12.7324 14.8403 12.2475 14.8403 11.9484 15.1393C11.6493 15.4384 11.6493 15.9233 11.9484 16.2224L14.5012 18.7752C14.648 18.922 14.8482 19.0029 15.0559 18.9993C15.2635 18.9958 15.4608 18.908 15.6025 18.7562L20.0699 13.9697Z"
        fill={fill}
      />
    </svg>
  );
};

export default FilledTick;
